import {apiSlice} from './apiSlice';

/**
 * Endpoints tool Site Crawler (bên trong một Project).
 *
 * - getProjectCrawls: thông tin project + lịch sử các lần crawl (trang tool crawler).
 * - runCrawl: bắt đầu 1 lần crawl với cấu hình (max_depth/max_pages/delay/robots).
 * - getCrawlStatus: FE POLL tiến độ khi đang running (pollingInterval set ở component).
 * - getCrawlReport: báo cáo đầy đủ Tầng A + Tầng B khi crawl xong.
 * - getCrawlPage: chi tiết 1 trang (trả eval_json để tái dùng component SeoResult).
 * - getCrawlCompare: so sánh 2 lần crawl (diff điểm/lỗi/URL mới-mất/trang tụt-tăng điểm).
 * - updateCrawlSchedule: bật/tắt crawl định kỳ (off/daily/weekly/monthly) cho project.
 *
 * Quản lý Project (CRUD) nằm ở reduxs/api/projectApiSlice.js.
 */
export const crawlerApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getProjectCrawls: builder.query({
			query: (projectId) => ({url: `crawler/projects/${projectId}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, projectId) => [{type: 'Crawl', id: `project-${projectId}`}],
		}),
		runCrawl: builder.mutation({
			query: ({projectId, ...config}) => ({url: `crawler/projects/${projectId}/run`, method: 'post', data: config}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: (result, error, {projectId}) => [{type: 'Crawl', id: `project-${projectId}`}],
		}),
		getCrawlStatus: builder.query({
			query: (id) => ({url: `crawler/crawls/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'Crawl', id}],
		}),
		getCrawlReport: builder.query({
			query: (id) => ({url: `crawler/crawls/${id}/report`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'Crawl', id: `report-${id}`}],
		}),
		getCrawlPage: builder.query({
			query: (id) => ({url: `crawler/pages/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
		}),
		getCrawlCompare: builder.query({
			query: ({a, b}) => ({url: `crawler/crawls/${a}/compare/${b}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
		}),
		deleteCrawl: builder.mutation({
			query: (id) => ({url: `crawler/crawls/${id}`, method: 'delete'}),
			invalidatesTags: ['Crawl'],
		}),
		updateCrawlSchedule: builder.mutation({
			query: ({projectId, schedule}) => ({url: `crawler/projects/${projectId}/schedule`, method: 'put', data: {schedule}}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: (result, error, {projectId}) => [{type: 'Crawl', id: `project-${projectId}`}],
		}),
		// Đánh dấu xử lý issue (đang làm/đã sửa/bỏ qua) — khoá (type, ref) giữ qua các lần crawl.
		getIssueMarks: builder.query({
			query: (projectId) => ({url: `crawler/projects/${projectId}/issue-marks`, method: 'get'}),
			transformResponse: (body) => body?.data?.marks || [],
			providesTags: (result, error, projectId) => [{type: 'Crawl', id: `marks-${projectId}`}],
		}),
		setIssueMark: builder.mutation({
			query: ({projectId, type, ref, status}) => ({url: `crawler/projects/${projectId}/issue-marks`, method: 'put', data: {type, ref, status}}),
			invalidatesTags: (result, error, {projectId}) => [{type: 'Crawl', id: `marks-${projectId}`}],
		}),
	}),
});

export const {
	useGetProjectCrawlsQuery,
	useRunCrawlMutation,
	useGetCrawlStatusQuery,
	useGetCrawlReportQuery,
	useGetCrawlPageQuery,
	useGetCrawlCompareQuery,
	useDeleteCrawlMutation,
	useUpdateCrawlScheduleMutation,
	useGetIssueMarksQuery,
	useSetIssueMarkMutation,
} = crawlerApiSlice;
